const AppHeader = () => {
	return (
		<header className="App__header">
			<h1>Days to Halloween</h1>
		</header>
	);
};

export default AppHeader;
